var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKFoldOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 13.5011H14.9994H1H0.5V13.0011V1.00054V0.50058L0.99996 0.50054L8.00016 0.50004L8.5002 0.5V1.00004V2.50124H15.0004H15.5004V3.00124V13.0001V13.5001L15.0004 13.5011Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0004 13.0011V3.0012H8.0002V1L1 1.0005V13.0011H15.0004ZM15.0004 14.0011H1C0.44772 14.0011 0 13.5534 0 13.0011V1.0005C0 0.44824 0.44767 0.000540021 0.99993 0.000500086L8.00013 2.85487e-09C8.26536 -2.00243e-05 8.51973 0.10533 8.70728 0.29287C8.89483 0.48041 9.0002 0.73477 9.0002 1V2.0012H15.0004C15.5527 2.0012 16.0004 2.44892 16.0004 3.0012V13.0001C16.0004 13.5524 15.5527 14.0011 15.0004 14.0011Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.6199L3.951 7.53689C3.951 7.53689 18.459 7.45389 18.459 7.53689C18.459 7.61989 15.344 13.6199 15.344 13.6199H1Z",
    fill: "#AECDFC",
    stroke: "#AECDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKFoldOperationIcon);
export default __webpack_public_path__ + "static/media/KFoldOperationIcon.fba9b0169e8739e3b000ce02d4be5944.svg";
export { ForwardRef as ReactComponent };